export type Rental = {
  address: string;
  listingUrl: string;
};

export const rentals: Rental[] = [
  {
    address: "15 Harbour Isle Dr W PH 5",
    listingUrl: "https://www.flexmls.com/share/Ecq1X/15-HARBOUR-ISLE-Drive-W-PH05,-Fort-Pierce,-FL-34949",
  },
  {
    address: "12 Harbour Isle Dr W #306",
    listingUrl: "https://www.flexmls.com/share/Ecq2x/12-HARBOUR-ISLE-Drive-W-306,-Fort-Pierce,-FL-34949",
  },
  {
    address: "29 Harbour Isle Dr W #304",
    listingUrl: "https://www.flexmls.com/share/Ecq4U/29-Harbour-Isle-Drive-W-304,-Fort-Pierce,-FL-34949",
  },
  {
    address: "7 Harbour Isle Dr E #304",
    listingUrl: "https://www.flexmls.com/share/Ecq62/7-HARBOUR-ISLE-Drive-E-304,-Fort-Pierce,-FL-34949",
  },
];
